var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 4C2.67157 4 2 4.67157 2 5.5V14.5C2 15.3284 2.67157 16 3.5 16H16.5C17.3284 16 18 15.3284 18 14.5V5.5C18 4.67157 17.3284 4 16.5 4H3.5ZM5.51452 6.14251C5.04094 5.85836 4.42668 6.01192 4.14254 6.4855C3.85839 6.95908 4.01195 7.57334 4.48553 7.85749L9.48553 10.8575C9.80222 11.0475 10.1978 11.0475 10.5145 10.8575L15.5145 7.85749C15.9881 7.57334 16.1417 6.95908 15.8575 6.4855C15.5734 6.01192 14.9591 5.85836 14.4855 6.14251L10 8.83381L5.51452 6.14251Z",
    fill: "#AFB3B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e4f178edef27089c82171fd2d9c1bf86.svg";
export { ForwardRef as ReactComponent };